import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { SignInUser } from '../interfaces/sign-in-user';
@Injectable({
    providedIn: 'root'
})
export class ExocetService {
    private readonly exocetUrl = `${environment.CONSTANTS.EXOCET_URL}`;

    constructor(protected http: HttpClient) { }

    public async signIn(user: SignInUser, rToken: string, retailCode: string, distributorRef: string): Promise<any> {
        const payload = {
            ...user,
            r_token: rToken,
            retail: retailCode,
            distributor_ref : distributorRef
        };
        return this.http.post(`${this.exocetUrl}/api/v2/users/onboarding`, payload).toPromise();
    }
}
